import { History } from "history";

import {
  ADD_CITY,
  ADD_CITY_ERROR,
  ADD_CITY_SUCCESS,
  AddCityAction,
  AddCityErrorAction,
  AddCitySuccessAction,
  DELETE_CITY,
  DELETE_CITY_CONSENT,
  DELETE_CITY_ERROR,
  DELETE_CITY_SUCCESS,
  DeleteCityAction,
  DeleteCityConsentAction,
  DeleteCityErrorAction,
  DeleteCitySuccessAction,
  GET_CITY,
  GET_CITIES,
  GET_CITIES_ERROR,
  GET_CITIES_SUCCESS,
  GET_CITY_ERROR,
  GET_CITY_SELECT_LIST,
  GET_CITY_SELECT_LIST_ERROR,
  GET_CITY_SELECT_LIST_SUCCESS,
  GET_CITY_SUCCESS,
  GetCityAction,
  GetCityErrorAction,
  GetCitySelectListAction,
  GetCitySelectListErrorAction,
  GetCitySelectListSuccessAction,
  GetCitySuccessAction,
  GetCitiesAction,
  GetCitiesErrorAction,
  GetCitiesSuccessAction,
  UPDATE_CITY,
  UPDATE_CITY_ERROR,
  UPDATE_CITY_SUCCESS,
  UpdateCityAction,
  UpdateCityErrorAction,
  UpdateCitySuccessAction,
  RESET_CITY_SELECT_LIST,
  ResetCitySelectListAction,
} from "./actionTypes";
import {
  CreateCityRequest,
  CityDto,
  PaginateQuery,
  UpdateCityRequest,
} from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";

//#region Get Cities

export const getCities = (
  request: PaginateQuery,
  history: History
): GetCitiesAction => {
  return {
    type: GET_CITIES,
    payload: { request, history },
  };
};

export const getCitiesSuccess = (
  response: Paginated<CityDto>
): GetCitiesSuccessAction => {
  return {
    type: GET_CITIES_SUCCESS,
    payload: response,
  };
};

export const getCitiesError = (error: any): GetCitiesErrorAction => {
  return {
    type: GET_CITIES_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get City

export const getCity = (id: string, history: History): GetCityAction => {
  return {
    type: GET_CITY,
    payload: { id, history },
  };
};

export const getCitySuccess = (response: CityDto): GetCitySuccessAction => {
  return {
    type: GET_CITY_SUCCESS,
    payload: response,
  };
};

export const getCityError = (error: any): GetCityErrorAction => {
  return {
    type: GET_CITY_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get City Select List

export const getCitySelectList = (
  history: History,
  governorateId?: string
): GetCitySelectListAction => {
  return {
    type: GET_CITY_SELECT_LIST,
    payload: { governorateId, history },
  };
};

export const getCitySelectListSuccess = (
  response: SelectListDto[]
): GetCitySelectListSuccessAction => {
  return {
    type: GET_CITY_SELECT_LIST_SUCCESS,
    payload: response,
  };
};

export const getCitySelectListError = (
  error: any
): GetCitySelectListErrorAction => {
  return {
    type: GET_CITY_SELECT_LIST_ERROR,
    payload: error,
  };
};

export const resetCitySelectList = (): ResetCitySelectListAction => {
  return {
    type: RESET_CITY_SELECT_LIST,
    payload: null,
  };
};

//#endregion

//#region Add City

export const addCity = (
  request: CreateCityRequest,
  history: History
): AddCityAction => {
  return {
    type: ADD_CITY,
    payload: { request, history },
  };
};

export const addCitySuccess = (): AddCitySuccessAction => {
  return {
    type: ADD_CITY_SUCCESS,
    payload: null,
  };
};

export const addCityError = (error: any): AddCityErrorAction => {
  return {
    type: ADD_CITY_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update City

export const updateCity = (
  id: string,
  request: UpdateCityRequest,
  history: History
): UpdateCityAction => {
  return {
    type: UPDATE_CITY,
    payload: { id, request, history },
  };
};

export const updateCitySuccess = (): UpdateCitySuccessAction => {
  return {
    type: UPDATE_CITY_SUCCESS,
    payload: null,
  };
};

export const updateCityError = (error: any): UpdateCityErrorAction => {
  return {
    type: UPDATE_CITY_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete City

export const deleteCityConsent = (id: string): DeleteCityConsentAction => {
  return {
    type: DELETE_CITY_CONSENT,
    payload: id,
  };
};

export const deleteCity = (id: string, history: History): DeleteCityAction => {
  return {
    type: DELETE_CITY,
    payload: { id, history },
  };
};

export const deleteCitySuccess = (): DeleteCitySuccessAction => {
  return {
    type: DELETE_CITY_SUCCESS,
    payload: null,
  };
};

export const deleteCityError = (error: any): DeleteCityErrorAction => {
  return {
    type: DELETE_CITY_ERROR,
    payload: error,
  };
};

//#endregion
